<template>
<section class="modal" @click="hideModal">
    <gifGenerator v-if="gifGeneratorVisible" :gifData="gifData" @gifImage="getGifImage" />
    <div class="modal-card" @click.stop>
        <div class="modal-head">
            <div v-if="currentStep == 1 || currentStep == 3" class="circle-btn close-circle-btn" @click="hideModal"></div>
            <div v-if="currentStep == 2" class="circle-btn back-circle-btn" @click="moveStepBackward"></div>
            <h4 v-if="stepsData['step'+ currentStep ].subtitle">{{stepsData['step'+ currentStep ].subtitle}}</h4>
            <h1>{{stepsData['step'+ currentStep ].title}}</h1>
        </div>
        
        <div class="modal-body" ref="modalBody">
            <gifCreationStep1 @stepData="fetchStepData($event, 'step1')" v-show="currentStep == 1" />
            <gifCreationStep2 @stepData="fetchStepData($event, 'step2')" v-show="currentStep == 2" />
            <gifCreationStep3
                @backToHomepage="hideModal"
                @stepData="fetchStepData($event, 'step3')"
                :gifImage="gifImage"
                :sharePostData="sharePostData"
            v-if="currentStep == 3" />
            
            <div class="form-validation-messages" v-if="validationErrors.length > 0">
                <div class="validation-messages-tite">
                    <!-- Please make sure to fill out all the empty fields: -->
                    Please review entered details:
                </div>
                <ul>
                    <li v-for="(errorMessage, index) in validationErrors" :key="index">→ {{errorMessage}}</li>
                </ul>
            </div>

        </div>
        
        <createGifStickyBar
            v-if="currentStep < 3" 
            :step="currentStep"
            @nextBtnClicked="moveStepForward"
        />
    </div>
</section>
</template>
            
<script>
import createGifStickyBar from './createGifStickyBar.vue'
import gifCreationStep1 from './gifCreationStep1.vue'
import gifCreationStep2 from './gifCreationStep2.vue'
import gifCreationStep3 from './gifCreationStep3.vue'
import gifGenerator from './gifGenerator.vue'

// Firebase
import firebase from 'firebase/app';
import 'firebase/database'
import 'firebase/storage'
import 'firebase/analytics'

export default {
    name: "createGifModal",
    components: {
        createGifStickyBar,
        gifCreationStep1,
        gifCreationStep2,
        gifCreationStep3,
        gifGenerator,
    },
    props: {
        pageTitle: String,
        pageSubtitle: String,
        stepNumber: Number,
    },
        data() {
        return {
            siteDomain: 'gifbanana.com',
            gifImage: {
                blobURL: null,
                imageBlob: null,
                url: null,
            },
            currentStep: 1,
            stepsData: {
                step1: {},
                step2: {},
                step3: {},
                // Steps needs to be declared in order to be reactive
            },
            validationErrors: [],
            gifGeneratorVisible: false,
            gifData: {
                quizQuestion: "",
                quizAnswers: [],
                quizColor: "",
                lightCard: null,
                creditInfo: {
                    name: "",
                    email: "",
                },
                quizIsPrivate: null,
            },
            sharePostData: {
                postID: null,
                gifURL: null,
            },
        }
    },
    methods: {
        fetchStepData(val, step) {
            this.stepsData[step] = val;
        },
        hideModal() {
             this.$emit('hideModal');
        },
        toggleBodyScroll() {
            // Stop page from scrolling
            const pageBody = document.body;
            if (pageBody.classList.contains('hideScroll')) {
                pageBody.classList.remove('hideScroll');
            } else {
                pageBody.classList.add('hideScroll');
            }
        },
        moveStepForward() {
            if (this.currentStep === 1) {
                // this.testingData();
                this.validateStep1();
            } else {
                if (this.validateStep2()) {
                    this.gifGeneratorVisible = true;
                    this.currentStep += 1;
                    this.clearValidationErrors();
                    this.createGifData();
                }
            }
        },
        moveStepBackward() {
            this.currentStep -= 1;
            this.clearValidationErrors();
        },
        validateStep1() {
            this.clearValidationErrors();
            let thisStep = this.stepsData.step1;

            // Validate question
            if (thisStep.quizQuestion == "") {
                this.validationErrors.push('Question field is empty');
            }
            
            // Validate answers
            if (thisStep.quizAnswers.length > 0) {
                thisStep.quizAnswers.forEach((answer, i) => {
                    if (answer == "") {
                        this.validationErrors.push('Answer ' + (i+1) + ' is empty');
                    }
                });
                
            }
            
            if (!this.validationErrors.length) {
                this.currentStep += 1;
                this.clearValidationErrors();
            }
            
        },
        clearValidationErrors() {
            this.validationErrors = [];
        },
        testingData() {
            this.stepsData.step1.quizQuestion = "question";
            this.stepsData.step1.quizAnswers = ['answer 1', 'answer 2', 'answer 3', 'answer 4', 'answer 5', 'answer 6', 'answer 7', 'answer 8', 'answer 9', 'answer 10', ];
            // this.stepsData.step1.quizAnswers = ['answer 1', 'answer 2', 'answer 3', ];

        },
        validateEmail(email) {
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
            // returns boolean
        },
        validateStep2() {
            let email = this.stepsData.step2.creditInfo.email;
            if (email) {
                // if user entered email validate it
                if (this.validateEmail(email)) {
                    return true;
                } else {
                    this.validationErrors.push('Email entered is invalid.');
                    return false;
                }
            } else {
                // else, skip this step if user didn't enter their email
                return true;
            }
        },
        createGifData() {
            this.gifData.quizQuestion = this.stepsData.step1.quizQuestion;
            this.gifData.quizAnswers = this.stepsData.step1.quizAnswers;
            this.gifData.quizColor = this.stepsData.step2.quizColor;
            this.gifData.lightCard = this.stepsData.step2.lightCard;
            this.gifData.creditInfo = this.stepsData.step2.creditInfo;
            this.gifData.quizIsPrivate = this.stepsData.step2.quizIsPrivate;
        },
        getGifImage(val) {
            // ==> NEW CODE
            this.gifImage.imageBlob = val.imageBlob;
            this.gifImage.blobURL = val.blobURL;

            // If the gifImage object doesn't have a ".url"
            // that means it hasn't been uploaded to the server yet
            if (val.url) {
                this.gifImage.url = val.url;                
            } else {
                this.addPostToDatabase();
            }
        },
        uploadFile(itemKey) {           
            // Get time in milliseconds
            let timeInMs = new Date().getTime();

            // Get file
            let file = this.gifImage.imageBlob;

            // Create a storage ref
            let storageRef = firebase.storage().ref();

            // Upload folder
            let uploadFolder = `posts/${itemKey}/`;
            
            // File name
            let fileName;
            
            if (this.gifData.creditInfo.name) {
                let creatorName = this.gifData.creditInfo.name.replace(' ', '-');
                fileName = `${this.siteDomain}-${creatorName}-${timeInMs}.gif`;
            } else {
                fileName = `${this.siteDomain}-Anonymous-${timeInMs}.gif`;
            }
            
            // Upload file
            let uploadTask = storageRef.child(uploadFolder + fileName).put(file);

            function uploadProgress(snapshot) {
                let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                return progress;
            }
            function uploadError(error) {
                console.error('error', error);
            }
            

            // Upload complete
            let that = this;
            function uploadComplete() {
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    that.gifImage.url = downloadURL;
                    that.sharePostData.gifURL = downloadURL;
                    
                    // Add URL to post in db once image is uploaded
                    // and update the isPrivate state
                    let newData = {
                        'private': that.gifData.quizIsPrivate,
                        image_url: that.gifImage.url
                    }
                    let database = firebase.database().ref(`posts/${itemKey}`);
                    database.update(newData);
                    
                })
            }

            let subscribe = uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED);
            subscribe({
                'next': uploadProgress,
                'error': uploadError,
                'complete': uploadComplete
            });
        },
        addPostToDatabase() {
            let database = firebase.database();
            let ref = database.ref('posts');
            let data = {
                creator: this.gifData.creditInfo.name,
                creator_email: this.gifData.creditInfo.email,
                timestamp: firebase.database.ServerValue.TIMESTAMP,
                private: true,
                image_url: null,
                quiz: {
                    question: this.gifData.quizQuestion,
                    answers: this.gifData.quizAnswers,
                },
            }
            if (!this.gifData.creditInfo.name) {
                data.creator = 'Anonymous';
            }
            ref.push(data)
                .then(snapshot=>{
                    if (snapshot) {
                        this.sharePostData.postID = snapshot.key;
                        
                        // Upload image after adding post to db to get a UID
                        this.uploadFile(snapshot.key);

                        // ==================================================
                        // Add time posted to localstorage to specify posting frequency
                        // Get post timestamp and save it in localstorage
                        this.getPostTimestamp(snapshot.key);
                        // ==================================================

                        
                    } else {
                        console.error('Error while posting', snapshot);
                    }
                });
        },
        getPostTimestamp(postId) {
            // Get post timestamp and save it in localstorage
            let postTimestamp;
            firebase.database().ref(`posts/${postId}`).once('value', snapshot=>{
                postTimestamp = snapshot.val().timestamp;
                localStorage.setItem('lastPosted', postTimestamp);
            });
        },
        scrollToTop() {
            this.$refs['modalBody'].scrollTo(0,0);
        },
    },
    mounted() {
        this.toggleBodyScroll();
        this.scrollToTop(); // This is needed for mobile to make sure content is above keyboard
    },
    destroyed() {
        this.toggleBodyScroll();
    }
}
</script>

<style>
.form-validation-messages {
    background: rgba(250, 78, 40, 0.05);
    font-size: calc(14em / 16);
    padding: calc(16em / 14);
    border-radius: 8px;
    width: 100%;
    margin-top: 40px;
    color: #FA4E28;
}

.form-validation-messages .validation-messages-tite {
    font-weight: 600;
    margin-bottom: calc(8em / 14);
}

.form-validation-messages ul {
    list-style: none;
}

.form-validation-messages li {
    margin-bottom: calc(2em / 14);
}



</style>